import { useState } from "react";
import "./editorialForms.css";

const workoutTypes = [
  { id: "strength", name: "Musculação" },
  { id: "cardio", name: "Cardio" },
  { id: "hiit", name: "HIIT" },
  { id: "flexibility", name: "Flexibilidade" },
  { id: "crossfit", name: "CrossFit" },
  { id: "functional", name: "Funcional" },
  { id: "bodyweight", name: "Peso Corporal" },
  { id: "pilates", name: "Pilates" },
  { id: "stretching", name: "Alongamento" },
];

const difficulties = [
  { id: "beginner", name: "Iniciante" },
  { id: "intermediate", name: "Intermediário" },
  { id: "advanced", name: "Avançado" },
];

const muscleGroups = [
  "Peito",
  "Costas",
  "Ombros",
  "Bíceps",
  "Tríceps",
  "Abdômen",
  "Glúteos",
  "Quadríceps",
  "Posterior",
  "Panturrilha",
  "Core",
  "Corpo Inteiro",
];

export default function ExerciseForm({ data, onChange }) {
  const [exerciseInput, setExerciseInput] = useState({
    name: "",
    sets: "",
    reps: "",
    duration: "",
  });
  const [equipmentInput, setEquipmentInput] = useState("");

  const handleAddExercise = () => {
    if (exerciseInput.name.trim()) {
      onChange({
        ...data,
        exercises: [
          ...(data?.exercises || []),
          {
            name: exerciseInput.name.trim(),
            sets: parseInt(exerciseInput.sets) || 0,
            reps: parseInt(exerciseInput.reps) || 0,
            duration: parseInt(exerciseInput.duration) || 0,
            restTime: 60,
          },
        ],
      });
      setExerciseInput({ name: "", sets: "", reps: "", duration: "" });
    }
  };

  const handleRemoveExercise = (index) => {
    onChange({
      ...data,
      exercises: (data?.exercises || []).filter((_, i) => i !== index),
    });
  };

  const handleToggleMuscle = (muscle) => {
    const current = data?.muscleGroups || [];
    if (current.includes(muscle)) {
      onChange({
        ...data,
        muscleGroups: current.filter((m) => m !== muscle),
      });
    } else {
      onChange({
        ...data,
        muscleGroups: [...current, muscle],
      });
    }
  };

  const handleAddEquipment = () => {
    if (equipmentInput.trim()) {
      onChange({
        ...data,
        equipment: [...(data?.equipment || []), equipmentInput.trim()],
      });
      setEquipmentInput("");
    }
  };

  const handleRemoveEquipment = (index) => {
    onChange({
      ...data,
      equipment: (data?.equipment || []).filter((_, i) => i !== index),
    });
  };

  return (
    <div className="editorial_form exercise_form">
      <div className="editorial_form_section">
        <label>
          Nome do Treino <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Treino de Peito e Tríceps, HIIT 30min..."
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descrição</label>
        <textarea
          placeholder="Descreva o treino, dicas de execução, quem é o público alvo..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={1000}
          rows={3}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Tipo de Treino</label>
          <select
            value={data?.workoutType || ""}
            onChange={(e) => onChange({ ...data, workoutType: e.target.value })}
          >
            <option value="">Selecione</option>
            {workoutTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Dificuldade</label>
          <select
            value={data?.difficulty || ""}
            onChange={(e) => onChange({ ...data, difficulty: e.target.value })}
          >
            <option value="">Selecione</option>
            {difficulties.map((diff) => (
              <option key={diff.id} value={diff.id}>
                {diff.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Duração Total (min)</label>
          <input
            type="number"
            placeholder="45"
            value={data?.duration || ""}
            onChange={(e) =>
              onChange({ ...data, duration: parseInt(e.target.value) || 0 })
            }
            min="0"
          />
        </div>

        <div className="editorial_form_section">
          <label>Calorias Estimadas</label>
          <input
            type="number"
            placeholder="300"
            value={data?.calories || ""}
            onChange={(e) =>
              onChange({ ...data, calories: parseInt(e.target.value) || 0 })
            }
            min="0"
          />
        </div>

        <div className="editorial_form_section">
          <label>Instrutor(a)</label>
          <input
            type="text"
            placeholder="Nome"
            value={data?.instructor || ""}
            onChange={(e) => onChange({ ...data, instructor: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Grupos Musculares</label>
        <div className="genre_chips">
          {muscleGroups.map((muscle) => (
            <span
              key={muscle}
              className={`genre_chip ${
                (data?.muscleGroups || []).includes(muscle) ? "selected" : ""
              }`}
              onClick={() => handleToggleMuscle(muscle)}
            >
              {muscle}
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Lista de Exercícios
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddExercise}
          >
            + Adicionar
          </button>
        </label>
        <div className="editorial_form_row" style={{ marginBottom: "8px" }}>
          <input
            type="text"
            placeholder="Nome do exercício"
            value={exerciseInput.name}
            onChange={(e) =>
              setExerciseInput({ ...exerciseInput, name: e.target.value })
            }
            style={{ flex: 3 }}
          />
          <input
            type="number"
            placeholder="Séries"
            value={exerciseInput.sets}
            onChange={(e) =>
              setExerciseInput({ ...exerciseInput, sets: e.target.value })
            }
            min="0"
            style={{ flex: 1 }}
          />
          <input
            type="number"
            placeholder="Reps"
            value={exerciseInput.reps}
            onChange={(e) =>
              setExerciseInput({ ...exerciseInput, reps: e.target.value })
            }
            min="0"
            style={{ flex: 1 }}
          />
          <input
            type="number"
            placeholder="Seg"
            value={exerciseInput.duration}
            onChange={(e) =>
              setExerciseInput({ ...exerciseInput, duration: e.target.value })
            }
            min="0"
            style={{ flex: 1 }}
          />
        </div>
        {(data?.exercises || []).length > 0 && (
          <div style={{ marginTop: "8px" }}>
            {data.exercises.map((ex, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px",
                  background: "var(--bg-third)",
                  borderRadius: "6px",
                  marginBottom: "4px",
                }}
              >
                <span>
                  <strong>{ex.name}</strong>
                  {ex.sets > 0 && ex.reps > 0 && ` - ${ex.sets}x${ex.reps}`}
                  {ex.duration > 0 && ` - ${ex.duration}s`}
                </span>
                <button
                  type="button"
                  className="remove_variant_btn"
                  onClick={() => handleRemoveExercise(i)}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="editorial_form_section">
        <label>
          Equipamentos
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddEquipment}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Ex: Halteres, Barra, Corda..."
          value={equipmentInput}
          onChange={(e) => setEquipmentInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddEquipment()}
        />
        <div className="genre_chips" style={{ marginTop: "8px" }}>
          {(data?.equipment || []).map((item, i) => (
            <span
              key={i}
              className="genre_chip selected"
              onClick={() => handleRemoveEquipment(i)}
              style={{ cursor: "pointer" }}
            >
              {item} ×
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29l-1.43-1.43z" />
        </svg>
        <span>
          Adicione um vídeo demonstrativo de cada exercício para melhores resultados!
        </span>
      </div>
    </div>
  );
}
